import React, { useState, useEffect } from "react";
import "./TestStyles.css";
import { Link } from "react-router-dom";
import { initializeResults } from "../db/localstorage_utils.js";

const StartScreen = () => {
  const [nextPage] = useState('/Q16Screen');        // Where this screen will navigate to next
  const [thisPage] = useState("StartScreen");  
  
  useEffect(() => {
    initializeResults();
  }, []);
  return (
    <div className={thisPage}>
      <p className="StartScreenTitle">Autonomous Cognitive Examination</p>
      <Link to={nextPage}>
        <button><img src="/icons/next.png" alt="Next Button" /></button>
      </Link>
      <p>Version 2.0.1</p>
    </div>
  );
};

export default StartScreen;
